export default __webpack_public_path__ + "static/media/image-work-company-w@2x.9564e0e0.png";